import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { TableColumn, ButtonTableColumn } from '../table.column';
import { TableElement } from '../table.element';

export class ButtonComponentEvent {
  element: TableElement;
  column: TableColumn;

  public constructor(element: TableElement, column: TableColumn) {
    this.element = element;
    this.column = column;
  }

  public getElement(): TableElement {
    return this.element;
  }

  public getColumn(): TableColumn {
    return this.column;
  }
}

@Component({
  selector: 'app-table-widget-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent extends WidgetComponent implements OnInit {

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }

  onClicked($event: any): void {
    if ($event.screenX !== 0 || $event.screenY !== 0) {
      this.table.onButtonClicked(new ButtonComponentEvent(this.tableElement, this.tableColumn));
    }
    // $event.stopPropagation();
  }

  public getContent() {
    if (!this._content) {
      if (this.tableColumn.decorator) {
        this._content = super.getContent();
      } else {
        this._content = this.tableColumn.caption;
      }  
    }
    return this._content;
  }

  public getColor(): string {
    const column: ButtonTableColumn = this.tableColumn as ButtonTableColumn;

    return column.color;  
  }

  public getStyles(): string {
    const column: ButtonTableColumn = this.tableColumn as ButtonTableColumn;

    if (column.styles) {
      return column.styles;
    } else {
      return null;
    }
  }

  public getOption(option: string) : boolean {
    const column: ButtonTableColumn = this.tableColumn as ButtonTableColumn;

    if (column.options) {
      return column.options[option];
    } else {
      if (option === 'raised') {
        return true;
      } else if (option === 'caption') {
        return true;
      } else {
        return false;
      }
    }
  }
}
